<template>
  <b-modal
    v-model="localShowDetailModal"
    :title="`Confirmation Submit - ${titleCase(activeTab)}`"
    size="xl"
    hide-footer
    @hide="$emit('close')"
  >
    <div v-if="activeTab && selectedItems">
      <!-- Training Plan Kanban (hanya untuk tab structured) -->
      <div class="mb-4">
        <p v-if="filteredItems.length === 0" class="text-muted">
          Tidak ada item yang perlu di-submit. Semua item sudah approved atau
          merupakan mandatory training.
        </p>
        <div v-else>
          <TrainingPlanKanban ref="kanban" :externalItems="filteredItems" @plan-updated="onPlanUpdated" @open-training-detail="handleOpenTrainingDetail" />
          <hr />
        </div>
      </div>
      <b-button
        variant="primary"
        @click="handleSubmit"
        :disabled="isSubmitting || filteredItems.length === 0"
      >
        Submit {{ titleCase(activeTab) }}
      </b-button>
    </div>
    <!-- Detail Training Modal -->
    <DetailTNA
      :isLoadingModal="isLoadingDetailTraining"
      :showDetailModal="showDetailTrainingModal"
      :selectedTNA="selectedTraining"
      @close="showDetailTrainingModal = false"
    />
  </b-modal>
</template>

<script>
import { titleCase } from "@/utils/titleCase";
import TrainingPlanKanban from "@/views/mytna/components/training-plan-kanban.vue";
import DetailTNA from "@/views/mytna/modal/DetailTNA.vue";

export default {
  name: "ConfirmationSubmit",
  components: { TrainingPlanKanban, DetailTNA },
  data() {
    return {
      trainingPlan: [],
      showDetailTrainingModal: false,
      selectedTraining: null,
      isLoadingDetailTraining: false,
    };
  },
  props: {
    showConfirmationSubmit: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: "structured",
    },
    selectedItems: {
      type: Object,
      default: () => ({ structured: [], social: [], experiential: [] }),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localShowDetailModal: {
      get() {
        return this.showConfirmationSubmit;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    filteredItems() {
      const items = this.selectedItems[this.activeTab] || [];
      return items.filter((item) => {
        // Filter out items that are already approved
        if (item.status && item.status.toLowerCase() != "open") return false;
        return true;
      });
    },
  },
  methods: {
    titleCase,
    handleSubmit() {
      // Gunakan trainingPlan dari state, fallback ke data langsung dari ref kanban
      const plan = this.trainingPlan.length
        ? this.trainingPlan
        : (this.$refs.kanban?.columns || []).map((col) => ({
            year: col.year,
            trainings: col.items,
          }));
      this.$emit("submit", this.activeTab, this.selectedItems[this.activeTab], plan);
    },
    onPlanUpdated(columns) {
      this.trainingPlan = columns.map((col) => ({
        year: col.year,
        trainings: col.items,
      }));
      this.$emit("plan-updated", this.trainingPlan);
    },
    handleOpenTrainingDetail(training) {
      this.selectedTraining = training;
      this.showDetailTrainingModal = true;
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
